!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r(require("react")) : "function" == typeof define && define.amd ? define(["react"], r) : "object" == typeof exports ? exports.ASCButton = r(require("react")) : e.ASCButton = r(e.react);
}(window, function (e) {
  return function (e) {
    var r = {};

    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        enumerable: !0,
        get: n
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, r) {
      if (1 & r && (e = t(e)), 8 & r) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (t.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & r && "string" != typeof e) for (var o in e) {
        t.d(n, o, function (r) {
          return e[r];
        }.bind(null, o));
      }
      return n;
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.p = "", t(t.s = 1);
  }([function (r, t) {
    r.exports = e;
  }, function (e, r, t) {
    "use strict";

    t.r(r);
    var n = t(0),
        o = t.n(n),
        i = {
      primary: "border-blue-500 bg-blue-500 hover:bg-blue-600 text-white",
      secondary: "bg-white border-blue-500 hover:bg-gray-100 text-blue-500",
      tertiary: "bg-white text-gray-700 border-gray-400 hover:bg-gray-100",
      save: "border-green-500 bg-green-500 hover:bg-green-600 text-white",
      delete: "border-red-500 bg-red-500 hover:bg-red-600 text-white",
      alert: "border-white bg-red-500 hover:bg-red-600 text-white"
    },
        u = {
      sm: "h-10 px-3 text-sm",
      md: "h-12 px-14px text-base",
      lg: "h-50px px-5 text-lg"
    };

    r.default = function (e) {
      var r = e.size,
          t = e.type,
          n = e.href,
          d = e.children,
          a = e.onClick,
          l = e.id,
          c = i[t] + " " + u[r] + " inline-flex border-1 rounded-md shadow-md no-underline hover:no-underline whitespace-no-wrap cursor-pointer items-center";
      return o.a.createElement("a", {
        className: c,
        href: n,
        onClick: a,
        id: l
      }, d);
    };
  }]);
});